import PropTypes from "prop-types";
import React from "react";
import { Button, Col, FormControl, Row } from "react-bootstrap";

class MediaFolderCreateForm extends React.Component {
  static get displayName() {
    return "MediaFolderCreateForm";
  }

  static get propTypes() {
    return {
      createFolder: PropTypes.func.isRequired,
      onCreate: PropTypes.func,
      onCancel: PropTypes.func,
    };
  }

  constructor(props) {
    super(props);

    this.state = {
      folderName: "",
    };

    this._cancel = this._cancel.bind(this);
    this._create = this._create.bind(this);
    this._setName = this._setName.bind(this);
  }

  _create() {
    const { folderName } = this.state;
    const { createFolder, onCreate } = this.props;

    this.setState({
      folderName: "",
    });
    createFolder(folderName);
    if (onCreate) {
      onCreate();
    }
  }

  _setName(e) {
    this.setState({ folderName: e.target.value });
  }

  _cancel() {
    this.setState(
      {
        folderName: "",
      },
      () => {
        this.props.onCancel();
      },
    );
  }

  render() {
    const { onCancel } = this.props;
    const { folderName } = this.state;
    return (
      <div>
        <Row>
          <Col xs={onCancel ? 10 : 6}>
            <FormControl
              onChange={this._setName}
              placeholder="Enter folder name"
              type="text"
              value={folderName}
            />
          </Col>
          <Col xs={1}>
            <Button
              key="create-submit"
              className={`btn btn-${onCancel ? "primary" : "default"}`}
              disabled={!folderName}
              onClick={this._create}
            >
              Create
            </Button>
          </Col>
          {onCancel && (
            <Col xs={1}>
              <Button key="close-modal" onClick={this._cancel} variant="secondary">
                Cancel
              </Button>
            </Col>
          )}
        </Row>
      </div>
    );
  }
}

export { MediaFolderCreateForm };
